import React from 'react';

import SvgIcon from '../SvgIcon/SvgIcon';

function OnTimeIcon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M13.0001 7C13.0001 6.44772 12.5524 6 12.0001 6C11.4478 6 11.0001 6.44772 11.0001 7L11.0001 12C11.0001 12.2652 11.1054 12.5196 11.293 12.7071L14.293 15.7071C14.6835 16.0976 15.3167 16.0976 15.7072 15.7071C16.0977 15.3166 16.0977 14.6834 15.7072 14.2929L13.0001 11.5858L13.0001 7Z" fill="#62666B" />
            <path clipRule="evenodd" d="M22.0002 12C22.0002 17.5228 17.523 22 12.0001 22C6.47719 22 2 17.5228 2 12C2 6.47715 6.47719 2 12.0001 2C17.523 2 22.0002 6.47715 22.0002 12ZM20.0001 12C20.0001 16.4183 16.4184 20 12.0001 20C7.58176 20 4.00002 16.4183 4.00002 12C4.00002 7.58172 7.58176 4 12.0001 4C16.4184 4 20.0001 7.58172 20.0001 12Z" fill="#62666B" fillRule="evenodd" />
        </SvgIcon>
    );
}

export default OnTimeIcon;
